<template>
  <div class="row justify-content-center my-2">
    <router-link
      v-if="link"
      :to="{ name: link, query: query }"
      :class="['btn', 'btn-navigation', color]"
      type="button"
      @click="$emit('click')"
    >
      {{ text }}
    </router-link>

    <button
      v-else-if="disabled"
      :class="['btn', 'btn-navigation', color, 'disabled']"
      disabled
    >
      {{ text }}
    </button>
    <button
      v-else
      :class="['btn', 'btn-navigation', color]"
      type="button"
      @click="$emit('click')"
    >
      {{ text }}
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      color: {
        default: 'btn-primary',
        required: false,
        type: String
      },
      disabled: {
        default: false,
        required: false,
        type: Boolean
      },
      text: {
        default: 'Next',
        required: false,
        type: String
      },
      link: {
        default: null,
        required: false,
        type: String
      },
      query: {
        default: null,
        required: false,
        type: Object
      }
    }
  };
</script>
